import { render } from "./IntroPage.vue?vue&type=template&id=49781d78&scoped=true&ts=true"
import script from "./IntroPage.vue?vue&type=script&lang=ts"
export * from "./IntroPage.vue?vue&type=script&lang=ts"

import "./IntroPage.vue?vue&type=style&index=0&id=49781d78&lang=scss&scoped=true"

import exportComponent from "C:\\PROJEKTE\\GAMES\\shootEm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49781d78"]])

export default __exports__